module.exports = "https://bin.bnbstatic.com/_next/static/images/research-97034f5b3fdc529b2da5b856526a6210.png";